import { render, staticRenderFns } from "./user_order.vue?vue&type=template&id=2483bf64&scoped=true"
import script from "./user_order.vue?vue&type=script&lang=js"
export * from "./user_order.vue?vue&type=script&lang=js"
import style0 from "./user_order.vue?vue&type=style&index=0&id=2483bf64&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2483bf64",
  null
  
)

export default component.exports